import React, { useEffect, useState } from 'react';
import {Modal, Image} from 'react-bootstrap';
import SalirIcon from '../../../Images/salir.svg';
import OtherFile from '../../../Images/kyc/other_files.svg';
import RfcOrCurp from '../../../Images/kyc/rfc_curp.svg';
import Argentina from '../../../Images/kyc/Argentina.svg';
import Bolivia from '../../../Images/kyc/Bolivia.svg';
import Colombia from '../../../Images/kyc/Colombia.svg';
import Ecuador from '../../../Images/kyc/Ecuador.svg';
import Peru from '../../../Images/kyc/Peru.svg';
import '../index.css';

const HelpToolRfc = ({
  show,
  handleClose,
  entity,
  country,
  countryInc,
  countryRep,
  typeHelpRfc,
  labelRfc,
  ...props
}) => {
  const {help_tools} = props.traductions.kyc.form.moral;
  
  const handleIdentifierEntity = () => {
    console.log(country)
    if (entity === 'F'){
      switch(country){
        case 'Argentina':
          return Argentina
        case 'Bolivia, Plurinational State of':
          return Bolivia
        case 'Colombia':
          return Colombia
        case 'Ecuador':
          return Ecuador
        case 'Peru':
          return Peru
        default: 
          return RfcOrCurp
      }
    }
  }
  
  let imageTool = {}
  
  useEffect(() => {
  },[typeHelpRfc, country || countryInc || countryRep])

  return (
    <Modal
      id="modal-help-tools"
      show={show}
      onHide={() => {handleClose()}}
    >
      <Modal.Header  style={{display: 'flex', flexDirection: 'column', height: 45}} className='custom-header-settings'>
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
          <Image width={15} src={SalirIcon} onClick={() => handleClose()} alt="X" style={{cursor: 'pointer'}}/>
        </div>
      </Modal.Header>
      {
        typeHelpRfc !== '' && typeHelpRfc === 'rfc_company' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.rfcLabel !== '' ? props.rfcLabel : props.traductions.kyc.form.general.fiscalID}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.rfc_company_description}<br/>
            <span style={{color: '#959595', fontSize: 14}}>{help_tools.rfc_company_description_2}</span>
          </div>
        </div>
      }

      { typeHelpRfc !== '' && typeHelpRfc === 'rfc' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={handleIdentifierEntity()} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {labelRfc !== '' ? labelRfc : props.traductions.kyc.form.general.fiscalID}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.rfc_company_description}<br/>
            <span style={{color: '#959595', fontSize: 14}}>{help_tools.rfc_company_description_2}</span>
          </div>
        </div>
      }

      { typeHelpRfc !== '' && typeHelpRfc === 'rfc_rep' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.rfcLabel !== '' ? props.rfcLabel : props.traductions.kyc.form.general.fiscalID}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.rfc_company_description}<br/>
            <span style={{color: '#959595', fontSize: 14}}>{help_tools.rfc_company_description_2}</span>
          </div>
        </div>
      }
      
    </Modal>
  )
}

export default HelpToolRfc;